import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function FAQ() {
  return <section className="w-full bg-navy-950 py-14 sm:py-20" data-id="element-118" data-mp="38z20nwntbro2">
      <div className="mx-auto w-full max-w-3xl px-5" data-id="element-119" data-mp="2u5fhjj4vp25h">
        <h2 className="font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-120" data-mp="2z2yw6k5hngxy">
          Frequently Asked Questions
        </h2>

        <div className="mt-8 space-y-3" data-id="element-121" data-mp="3muw8eccuoazl">
          {faqs.map((faq, index) => <details key={faq.question} className="group rounded-2xl border border-white/10 bg-navy-900 px-5 py-4 [&_summary::-webkit-details-marker]:hidden" open={index === 0} data-id="element-122" data-mp="3rrctsyso0b8z" data-mpi={index}>
              <summary className="flex cursor-pointer items-start justify-between gap-4 font-display text-[1rem] font-extrabold text-white" data-id="element-123" data-mp="9m9njaqypt6z">
                {faq.question}
                <ChevronDownIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-500 transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-124" data-mp="eeax2owqx5tb" />
              </summary>
              <p className="mt-3 text-[0.93rem] leading-relaxed text-slate-300" data-id="element-125" data-mp="2ah1nvuqepycu">
                {faq.answer}
              </p>
            </details>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-126" data-mp="25nytxlhpwmw4">
          <CTAButton label="I’m ready — give me access" note="One-time payment · 7-day guarantee" data-id="element-127" data-mp="2jfwtp5pjh6fm" />
        </div>
      </div>
    </section>;
}